import React from 'react';
import { HeaderDesignControllerContextData } from 'src/hooks/useHeaderDesignController';
import { ButtonVariants } from 'src/api/models/Button';
import { ColorScheme } from 'src/styles/functions/getButtonStyleByColorScheme';
import LinkBranded from './LinkBranded';
import { StandardParagraphSize } from 'src/elements/typography/paragraph.styles';

interface SignInButtonWithIconProps {
  sizeSm?: string;
  standardSize?: StandardParagraphSize;
  parentBackgroundTheme: HeaderDesignControllerContextData['backgroundTheme'];
  buttonBaseColorScheme?: ColorScheme;
}

const SignInButton = ({
  parentBackgroundTheme,
  buttonBaseColorScheme = 'Black',
  standardSize = '1',
  sizeSm = null,
}: SignInButtonWithIconProps): JSX.Element => {
  const getColorFromTheme = (): { scheme: ColorScheme; variant: ButtonVariants } => {
    if (parentBackgroundTheme === 'dark') {
      return { scheme: buttonBaseColorScheme, variant: 'secondary' };
    }
    return { scheme: buttonBaseColorScheme, variant: 'primary' };
  };

  const color = getColorFromTheme();

  return (
    <LinkBranded
      url='https://mightynetworks.com/sign_in'
      id='sign-in-link'
      text='Log In'
      standardSize={standardSize}
      sizeSm={sizeSm}
      customFontWeight={700}
      colorScheme={color.scheme}
      colorSchemeVariant={color.variant}
      customBorderColor='transparent'
    />
  );
};

export default SignInButton;
